import { z } from 'zod'

export const fileDescriptionSchema = z.object({
  /** 使用說明與注意事項[英文] */
  englishDesc: z.string(),
  /** 使用說明與注意事項PDF檔案Id[英文] */
  englishDescFileId: z.string(),
  /** 使用說明與注意事項[簡體中文] */
  simplifiedDesc: z.string(),
  /** 使用說明與注意事項PDF檔案Id[簡體中文] */
  simplifiedDescFileId: z.string(),
  /** 使用說明與注意事項[繁體中文] */
  traditionalDesc: z.string(),
  /** 使用說明與注意事項PDF檔案Id[繁體中文] */
  traditionalDescFileId: z.string()
})

export interface FileDescription
  extends z.infer<typeof fileDescriptionSchema> {}
